export class stateUpdateRequest {
  stateId?:number;
  stateCode:string;
  stateName:string;
  createdUser:number | null;
  updatedUser: number | null;
  versionFlag: number;
}
export class stateIdRequest {
  stateId:string;
  updatedUser: number | null;
  versionFlag: number;
}
export class stateStatusUpdateRequest{
  stateCode:string;
  status:boolean;
}